/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAIcon20Light = forwardRef('MediaAudioVolumeAIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.943 1.663C13.755.975 15 1.553 15 2.617v14.766c0 1.064-1.245 1.642-2.057.954L7.817 14H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.817l5.126-4.337ZM14 2.617a.25.25 0 0 0-.412-.19L8.463 6.762A1 1 0 0 1 7.817 7H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.817a1 1 0 0 1 .646.237l5.126 4.337a.25.25 0 0 0 .411-.191V2.617Z" })));
});
